import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './Header';
import Profile from './Profile';
import Work from './Work';
import ProjectDetail from './ProjectDetail';
import Footer from './Footer';
import PageTitleUpdater from './PageTitleUpdater';
import { useTheme } from './ThemeContext';
import Cursor from './Cursor'; // Import Cursor component

function App() {
  const { theme, isTransitioning} = useTheme();

  const bgColor = theme === 'dark' ? '#000' : '#fff';
  const textColor = theme === 'dark' ? '#fff' : '#000';


  return (
    <div className={`${theme} ${isTransitioning ? 'transitioning' : ''}`} style={{ height: '100%', backgroundColor: bgColor, color: textColor }}>
      {window.innerWidth > 768 && <Cursor />} {/* Add condition to render Cursor component */}
      <Router>
        <PageTitleUpdater defaultTitle="Brian Sanchez Ramirez" />
        <Header />
        <Routes>
          <Route exact path="/" element={<Work />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/work/:id" element={<ProjectDetail />} />
        </Routes>
        <Footer />
        <div className={`clip ${isTransitioning ? 'anim' : ''}`} />
      </Router>
    </div>
  );
}

export default App;
